"use client";

import styles from "./Request.module.css";
import useUiStore from "./store/uiStore"; // Zustand 스토어 import
import RequestForm from "./RequestForm"; // RequestForm import
import { useEffect, useRef } from "react";

export default function Request({ setFooterActive }) {
    const requestRef = useRef(null);
    const showForm = useUiStore((state) => state.showForm); // 스토어에서 showForm 함수 가져오기
    useUiStore((state) => state.isFormVisible); // 스토어에서 폼 가시성 상태 가져오기

    const steps = [
        {
            id: '01',
            title: '상담문의',
            description: '제안서 및 \n견적서 발송'
        },
        {
            id: '02',
            title: '과정기획',
            description: '구체적 내용 및\n세부 일정 조율'
        },
        {
            id: '03',
            title: '과정진행',
            description: '적합 운영 및\n현장 진행'
        },
        {
            id: '04',
            title: '피드백',
            description: '결과보고서\n피드백 제출'
        }
    ];

    // 데스크탑에서만 마우스 이벤트 처리 (1024px 초과)
    useEffect(() => {
        const handleResize = () => {
            const isDesktop = window.innerWidth > 1024;
            if (!isDesktop) {
                // 태블릿/모바일에서는 마우스 이벤트 제거
                return;
            }
        };

        const handleMouseMove = (e) => {
            // 데스크탑에서만 실행
            if (window.innerWidth <= 1024) return;

            const requestEl = requestRef.current;
            if (!requestEl) return;

            const rect = requestEl.getBoundingClientRect();
            const isInside =
                e.clientX >= rect.left &&
                e.clientX <= rect.right &&
                e.clientY >= rect.top &&
                e.clientY <= rect.bottom;

            setFooterActive(isInside);
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        // 데스크탑에서만 마우스 이벤트 추가
        if (window.innerWidth > 1024) {
            window.addEventListener("mousemove", handleMouseMove);
        }

        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("mousemove", handleMouseMove);
        };
    }, [setFooterActive]);

    return (
        <div ref={requestRef} className={styles.requestPosition}>
            <div className={styles.requestWrap}>
                <h3>Process & Contact Us</h3>
                <div className={styles.processWrap}>
                    <div className={styles.processContent}>
                        <span className={styles.span}>
                            <span>
                                “한국감성색채협회는 <br /> 개인과 단체의 브랜드 경쟁력을 높이는 색채 컨설팅 및 교육을
                                <br />  20명 이상의 연구원이 연구 진행하고 각 분야의 전문가 120명이 활동하고 있습니다.”
                            </span>
                        </span>
                        <div className={styles.processFlow}>
                            {steps.map((step, index) => (
                                <div key={step.id} className={styles.stepWrapper}>
                                    <div className={styles.step}>
                                        <span className={styles.stepNumber}>{step.id}</span>
                                        <h3 className={styles.stepTitle}>{step.title}</h3>
                                        <p className={styles.stepDescription}>{step.description}</p>
                                    </div>
                                </div> 
                            ))}
                        </div>
                    </div>
                    <div className={styles.line}></div>
                    <div className={styles.formWrap}>
                        {/* 데스크탑에서는 항상 폼 표시, 태블릿/모바일에서는 조건부 표시 */}
                        <RequestForm />
                    </div>
                </div>

            </div>
            {/* 1024px 이하에서 보일 버튼 */}
            <button className={styles.requestButton} onClick={showForm}>
                문의하기
            </button>

        </div>
    );
}